import { Head, router, useForm } from "@inertiajs/react"

import RecordForm from "@/components/record-form"
import RecordPageHeader from "@/components/ui/record-page-header"
import UserForm from "@/components/users/admin-user-form"
import AdminLayout from "@/layouts/admin-layout"
import { adminUserPath, adminUsersPath, editAdminUserPath } from "@/routes"
import type { Account, BreadcrumbItem, User } from "@/types"

export default function EditUser({
  user,
  accounts,
}: {
  user: User
  accounts: Account[]
}) {
  const breadcrumbs: BreadcrumbItem[] = [
    {
      title: "Users",
      href: adminUsersPath(),
    },
    {
      title: user.display_name,
      href: adminUserPath({ id: user.uid }),
    },
    {
      title: "Edit",
      href: editAdminUserPath({ id: user.uid }),
    },
  ]

  const { data, setData, patch, processing, errors } = useForm({
    user: {
      name: user.name,
      email: user.email,
      state: user.state as "active" | "inactive",
      avatar: null as File | null,
      account_uid: user.account_uid,
    },
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    patch(adminUserPath({ id: user.uid }), {
      forceFormData: true,
    })
  }

  function handleCancel() {
    router.visit(adminUserPath({ id: user.uid }))
  }

  return (
    <AdminLayout breadcrumbs={breadcrumbs}>
      <Head title={`Edit ${user.name}`} />
      <div className="flex h-full w-full flex-col gap-6 p-4">
        <div className="mx-auto w-full max-w-2xl">
          <RecordPageHeader title={user.name} state={user.state} />
        </div>
        <RecordForm
          submitLabel="Save"
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          processing={processing}
        >
          <UserForm
            data={data}
            mode="edit"
            setData={setData}
            errors={errors}
            avatarUrl={user.avatar_url ?? null}
            accounts={accounts}
          />
        </RecordForm>
      </div>
    </AdminLayout>
  )
}
